import {StructureType} from '../modules/common/enums/enums';
import { Injectable } from "@angular/core";

@Injectable()
export class BusinessSettings {
  readonly STRUCTURE_TYPES_WITH_SURFACE_AREA: StructureType[] = [StructureType.LIVINGUNIT, StructureType.COMMERCIALUNIT];
}
